import { FuelIcon, FuelLink, FuelTypography } from '@frete.com/fuel-react';
import React, { FC } from 'react';

import { FuelFlex } from '@frete.com/fuel-station-react';
import { dsTheme } from 'constants/styled.contants';
import * as Styled from './styled';

const EmptyProfileRefundableFare: FC = () => (
  <FuelFlex
    defaultProps={{ alignItems: 'center', justifyContent: 'center', customPadding: `${dsTheme.spacing.km16} 0 0 0` }}
  >
    <Styled.ContentPerfilRefundable>
      <FuelFlex
        defaultProps={{
          alignItems: 'center',
          customGap: `0 ${dsTheme.spacing.km2}`,
          customMargin: `0 0 ${dsTheme.spacing.km2} 0`,
        }}
      >
        <FuelIcon name="lock" size="tiny" iconStyle="filled" />
        <FuelTypography weight="bold" size="body-md" displayInline>
          Frete seguro e sem prejuízo!
        </FuelTypography>
      </FuelFlex>

      <FuelTypography size="body-sm" color="neutral-default" weight="medium">
        A Taxa de Segurança é paga pelos motoristas à Fretebras. Além de entregar benefícios para ele, a Taxa também
        reduz custos e riscos para a sua empresa. Veja os benefícios:
      </FuelTypography>

      <ul>
        <li>
          <FuelIcon name="money" size="small" iconStyle="filled" />
          <FuelTypography size="body-sm" weight="medium" color="neutral-default">
            Em caso de roubo da carga, a Fretebras reembolsa o valor da franquia do seu seguro;
          </FuelTypography>
        </li>
        <li>
          <FuelIcon name="user-star" size="small" iconStyle="filled" />
          <FuelTypography size="body-sm" weight="medium" color="neutral-default">
            Alta probabilidade de comparecimento do motorista pra carregar;
          </FuelTypography>
        </li>
      </ul>

      <FuelLink href={`${process.env.URL_LANDINGPAGE_TRANSACTION_FEE}`}>Saiba mais</FuelLink>
    </Styled.ContentPerfilRefundable>
  </FuelFlex>
);

export default EmptyProfileRefundableFare;
